import { Reducer } from 'redux';
import {
  UNI_ROLES,
  ENROLY_AGENT_ROLES,
  AGENT_ROLES,
  PARTNER_ROLES,
  IMMIGRATION_PROVIDER_ROLES,
} from '../../../store/auth/types';
import { StudentActionTypes } from '../types';
import { MessagesState } from './types';
import { IMessage } from '../../../types';

const initialState: MessagesState = [];

const reducer: Reducer<MessagesState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD: {
      return [];
    }
    case StudentActionTypes.GET_STUDENT_MESSAGES_SUCCESS: {
      let messages = action.payload.messages ?? [];

      messages = messages.map(item => ({ ...item, messageId: item.s_key?.split('#')?.[1] ?? 'NO S_KEY' }));
      return [...messages];
    }
    case StudentActionTypes.MARK_MESSAGES_READ_SUCCESS: {
      const { messageIds } = action.payload;
      const { userRole } = action.payload;

      messageIds.forEach((messageId: string) => {
        if (messageId) {
          const currentMessage = state.findIndex(item => item.messageId === messageId);
          state[currentMessage] = {
            ...state[currentMessage],
            ...(UNI_ROLES.includes(userRole) ? { uniRead: true } : {}),
            ...(ENROLY_AGENT_ROLES.includes(userRole) ? { adminRead: true } : {}),
            ...(AGENT_ROLES.includes(userRole) ? { agentRead: true } : {}),
            ...(PARTNER_ROLES.includes(userRole) ? { partnerRead: true } : {}),
            ...(IMMIGRATION_PROVIDER_ROLES.includes(userRole) ? { immigrationProviderRead: true } : {}),
          };
        }
      });
      return [...state];
    }
    case StudentActionTypes.MARK_MESSAGE_UNREAD_SUCCESS: {
      const { messageId } = action.payload;
      const { userRole } = action.payload;

      if (messageId) {
        const currentMessage = state.findIndex(item => item.messageId === messageId);
        state[currentMessage] = {
          ...state[currentMessage],
          ...(UNI_ROLES.includes(userRole) ? { uniRead: false } : {}),
          ...(ENROLY_AGENT_ROLES.includes(userRole) ? { adminRead: false } : {}),
          ...(AGENT_ROLES.includes(userRole) ? { agentRead: false } : {}),
          ...(PARTNER_ROLES.includes(userRole) ? { partnerRead: false } : {}),
          ...(IMMIGRATION_PROVIDER_ROLES.includes(userRole) ? { immigrationProviderRead: false } : {}),
        };
      }
      return [...state];
    }
    case StudentActionTypes.SAVE_MESSAGE: {
      const message: IMessage = action.payload;
      return [
        ...state,
        {
          ...message,
          isMessageError: false,
          isMessageSaving: true,
        },
      ];
    }
    case StudentActionTypes.SAVE_MESSAGE_SUCCESS: {
      const message: IMessage = action.payload;
      let msgs;
      if (state.length === 0) {
        msgs = [
          ...state,
          {
            ...message,
            isMessageError: false,
            isMessageSaving: false,
          },
        ];
      } else if (message.messageId) {
        msgs = [
          ...state.map((msg: IMessage) => {
            if (msg.messageId === message.messageId) {
              return {
                ...msg,
                isMessageError: false,
                isMessageSaving: false,
              };
            }
            return msg;
          }),
        ];
      } else {
        msgs = [
          ...state.slice(0, state.length - 1),
          {
            ...state[state.length - 1],
            isMessageError: false,
            isMessageSaving: false,
          },
        ];
      }
      return msgs.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj.createdAt).indexOf(obj.createdAt) === pos;
      });
    }
    case StudentActionTypes.SAVE_MESSAGE_FAILURE: {
      const message: IMessage = action.payload;
      let msgs;
      if (state.length === 0) {
        msgs = [
          ...state,
          {
            ...message,
            isMessageError: true,
            isMessageSaving: true,
          },
        ];
      } else {
        msgs = [
          ...state.slice(0, state.length - 1),
          {
            ...state[state.length - 1],
            isMessageError: true,
            isMessageSaving: true,
          },
        ];
      }
      return msgs.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj.createdAt).indexOf(obj.createdAt) === pos;
      });
    }
    case StudentActionTypes.NEW_MESSAGE: {
      const message: IMessage = action.payload;

      const msgs = [
        ...state,
        {
          ...message,
          isMessageError: false,
          isMessageSaving: false,
        },
      ];
      return msgs.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj.createdAt).indexOf(obj.createdAt) === pos;
      });
    }
    default:
      return state;
  }
};

export { reducer as messagesReducer };
